import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const MessageBlastGroupPermissionGate = (props: Omit<BasePermissionGateProps<"message-blast">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="message-blast"
		/>
	)
}

export default MessageBlastGroupPermissionGate
